import { Component } from '@angular/core';
import { GlucoseAddEditComponent } from './glucose-add-edit/glucose-add-edit.component';
import { IGlucoseDetailed } from 'src/app/interfaces/Glucose/IGlucoseDetailed';
import { Subject, takeUntil } from 'rxjs';
import { GlucoseService } from 'src/app/services/glucose.service';
import { TranslateService } from '@ngx-translate/core';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';
import Swal from 'sweetalert2';
import { glucoseRV } from 'src/app/interfaces/IReferenceValue';

@Component({
  selector: 'app-glucose',
  templateUrl: './glucose.component.html',
  styleUrls: ['./glucose.component.css'],
  standalone: false,
})
export class GlucoseComponent {
  public addComp = GlucoseAddEditComponent;

  private destroy$ = new Subject<void>();

  glucose?: IGlucoseDetailed[];
  isLoading: boolean = false;

  referenceValues = glucoseRV;

  constructor(
    private readonly glucoseService: GlucoseService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: IGlucoseDetailed) {
    this.glucoseService.glucoseModalSub.next(true);
    this.glucoseService.glucoseEditSub.next(item);
  }

  deleteFun(id: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder2'
      )} ${this.translate.instant('Glucose Record')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.glucoseService.deleteGlucose(id.toString()).subscribe({
          next: (d) => {
            this.swalToastService.toastSuccess('Glucose deleted successfully');
            this.glucoseService.deleteGlucoseFromTable(id.toString());
          },

          error: (err) => {
            this.swalToastService.toastError('Unable to delete Glucose');
          },
        });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Glucose record is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
  ngOnInit() {
    this.glucoseService.glucoseLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.glucoseService.glucoseDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IGlucoseDetailed[]) => {
        this.glucose = data;
      });

    this.glucoseService.getData();
  }
}
